module.exports = __webpack_public_path__ + "static/media/done_icon.0d42859d.png";